import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/objectWithoutPropertiesLoose';
import _Minus from '@lyearn/icons/dist/cjs/web/Minus';
import _CheckMark from '@lyearn/icons/dist/cjs/web/CheckMark';
import React__default from 'react';
import c from 'classnames';
import Stack from '../Stack/Stack.js';
import { checkBoxStyles, checkBoxFocusStyles } from './utils/styles.js';
import BaseCheckbox from '@mui/material/Checkbox';
import { CHECK_SIZE_CLASSES, SIZE_BORDER_RADIUS_CLASSES, INDETERMINATE_ICON_SIZE_CLASSES, CHECK_ICON_SIZE_CLASSES } from './utils/index.js';

var _excluded = ["className", "parent", "size"];
var getIcon = function getIcon(size) {
  var sizeClasses = CHECK_SIZE_CLASSES[size];
  var borderRadius = SIZE_BORDER_RADIUS_CLASSES[size];
  return /*#__PURE__*/React__default.createElement(Stack, {
    className: c(sizeClasses, borderRadius, 'border border-solid border-border-medium group-hover:border-border-dark')
  });
};
var getCheckedIcon = function getCheckedIcon(isParent, size) {
  var sizeClasses = CHECK_SIZE_CLASSES[size];
  var iconClasses = CHECK_ICON_SIZE_CLASSES[size];
  var borderRadius = SIZE_BORDER_RADIUS_CLASSES[size];
  if (isParent) {
    return /*#__PURE__*/React__default.createElement(Stack, {
      alignItems: "center",
      className: c(sizeClasses, borderRadius, 'border border-solid border-interactive-secondary-hover group-hover:border-interactive-secondary-active ly-checkbox'),
      justifyContent: "center"
    }, /*#__PURE__*/React__default.createElement(_CheckMark, {
      className: iconClasses,
      fillColorToken: "icon-active"
    }));
  }
  return /*#__PURE__*/React__default.createElement(Stack, {
    alignItems: "center",
    className: c(sizeClasses, borderRadius, 'border bg-interactive-primary group-hover:bg-interactive-primary-hover'),
    justifyContent: "center"
  }, /*#__PURE__*/React__default.createElement(_CheckMark, {
    className: iconClasses,
    fillColorToken: "icon-white"
  }));
};
var getIndeterminateIcon = function getIndeterminateIcon(size) {
  var sizeClasses = CHECK_SIZE_CLASSES[size];
  var iconClasses = INDETERMINATE_ICON_SIZE_CLASSES[size];
  var borderRadius = SIZE_BORDER_RADIUS_CLASSES[size];
  return /*#__PURE__*/React__default.createElement(Stack, {
    alignItems: "center",
    className: c(sizeClasses, borderRadius, 'border border-solid border-interactive-secondary-hover group-hover:border-interactive-secondary-active ly-checkbox'),
    justifyContent: "center"
  }, /*#__PURE__*/React__default.createElement(_Minus, {
    className: iconClasses,
    fillColorToken: "icon-active"
  }));
};
var DefaultCheckbox = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var className = props.className,
    _props$parent = props.parent,
    parent = _props$parent === void 0 ? false : _props$parent,
    _props$size = props.size,
    size = _props$size === void 0 ? 'medium' : _props$size,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  var icon = getIcon(size);
  var checkedIcon = getCheckedIcon(parent, size);
  var indeterminateIcon = getIndeterminateIcon(size);
  return /*#__PURE__*/React__default.createElement(BaseCheckbox, _extends({
    ref: ref,
    disableRipple: true,
    checkedIcon: checkedIcon,
    className: c('p-0 group', className, checkBoxStyles, checkBoxFocusStyles),
    icon: icon,
    indeterminateIcon: indeterminateIcon
  }, rest));
});
var DefaultCheckbox$1 = /*#__PURE__*/React__default.memo(DefaultCheckbox);

export { DefaultCheckbox$1 as default };
//# sourceMappingURL=DefaultCheckbox.js.map
